// @flow

import React from 'react'

type PropTypes = {
  campaigns: Array<{
    name: string,
    link: string,
  }>,
}

export default (props: PropTypes) =>
  props.campaigns.length > 0 ? (
    <section className="space-main__section">
      <h2 className="space-main__headline">
        <i className="icon icon-spm-present mr5" />
        {i18n.t('page.room.sponsorTitle')}
      </h2>
      <ul className="space-campaign__list">
        {props.campaigns.map((campaign, i) => (
          <li key={`sponsor_campaign_${i}`} className="space-campaign__item">
            <a href={campaign.link} target="_blank">
              <i className="fa fa-angle-right mr5" />
              {campaign.name}
            </a>
          </li>
        ))}
      </ul>
    </section>
  ) : null



// WEBPACK FOOTER //
// ./src/components/organisms/room/DetailSponsorSection/index.jsx